import { render } from "./PermissionData.vue?vue&type=template&id=8cc668b8&scoped=true"
import script from "./PermissionData.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionData.vue?vue&type=script&setup=true&lang=js"

import "./PermissionData.vue?vue&type=style&index=0&id=8cc668b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc668b8"],['__file',"src/pages/users/PermissionData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cc668b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cc668b8', __exports__)) {
    console.log('reload')
    api.reload('8cc668b8', __exports__)
  }
  
  module.hot.accept("./PermissionData.vue?vue&type=template&id=8cc668b8&scoped=true", () => {
    console.log('re-render')
    api.rerender('8cc668b8', render)
  })

}


export default __exports__